import { render, staticRenderFns } from "./popUpConfirmCountAccess.vue?vue&type=template&id=4821a25e&scoped=true&"
import script from "./popUpConfirmCountAccess.vue?vue&type=script&lang=ts&"
export * from "./popUpConfirmCountAccess.vue?vue&type=script&lang=ts&"
import style0 from "./popUpConfirmCountAccess.vue?vue&type=style&index=0&id=4821a25e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821a25e",
  null
  
)

export default component.exports